export const CREATE_REVIEW_ACTION = '[Review Action] Create Review';
export const CONFIRMED_CREATE_REVIEW_ACTION = '[Review Action] Confirmed Create Review';
export const CREATE_REVIEW_ERROR_ACTION = '[Review Action] Create Review Error';
export const GET_REVIEWS = '[Review Action] Get Reviews';
export const CONFIRMED_GET_REVIEWS = '[Review Action] Confirmed Get Reviews';
export const LOADING_REVIEWS = '[Review Action] Loading for Reviews';
export const EDIT_REVIEW_ACTION = '[Review Action] Edit Review';
export const CONFIRMED_EDIT_REVIEW_ACTION = '[Review Action] Confirmed Edit Review';
export const DELETE_REVIEW_ACTION = '[Review Action] Delete Review';
export const CONFIRMED_DELETE_REVIEW_ACTION = '[Review Action] Confirmed Delete Review';
export const REVIEW_ERROR_ACTION = '[Review Action] Error';
export const CLEAR_REVIEW_ERROR = '[Review Action] Clear Error';
export const CONFIRMED_UPDATE_REVIEW_STATUS_ACTION = '[Review Action] update status';
